<template>
    <div>
        <v-card>
            <v-card-actions class="mx-3">
                <v-spacer></v-spacer>
                <v-btn class="mr-3 mb-3 white--text" small color="green" depressed @click="export2xls">Export to XLS</v-btn>
            </v-card-actions>
            <v-card-subtitle>
                <div style="text-align:center; font-weight:bold; font-size:16px; padding:10px">Jalur Outlet</div>

                <v-row class="compact-form my-2">
                    <v-col cols="1">
                        Tanggal Kirim
                    </v-col>
                    <v-col cols="3" class="">
                        <v-menu v-model="dateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="reportDate" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="reportDate" ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="2">
                        <v-btn depressed color="primary" @click="runReport">Run</v-btn>
                    </v-col>
                </v-row>                

            </v-card-subtitle>

            <v-card-text class="ml-3 mr-3">

                <div style="overflow:auto">
                    <!-- <table style="width:98%; margin: 0px;" class="pdf-item" ref="tableBOM"> -->
                    <v-simple-table fixed-header height="400px" ref="tableBOM">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th><b>Jalur</b></th>
                                    <th><b>Outlet</b></th>
                                    <th><b>Jumlah Botol</b></th>
                                    <th><b>Tanggal Expired</b></th>
                                    <th><b>Jumlah Tester</b></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(obj, idx) in printObj" :key="idx">
                                    <td>{{obj.line_name}}</td>
                                    <td>{{obj.outlet_name}}</td>
                                    <td>{{obj.expired_date}}</td>
                                    <td>{{obj.quantity}}</td>
                                    <td>{{obj.quantity_tester}}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <!-- </table> -->
                </div>
            </v-card-text>
        </v-card>
        <v-overlay :value="onLoad" z-index="999">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>        

    </div>
</template>

<script>
import moment from 'moment'
import { utils, writeFileXLSX } from 'xlsx';

export default {

    data: () => ({
        dialog: false,
        onLoad: false,
        printObj: [],
        dateMenu: false,
        reportDate: null,
    }),

    computed: {
      miscCodes() {
        return this.$store.state.misccode.objs
      },
    },

    watch: {
    },

    filters: {
        moment: function (date) {
            return moment(date).format('D MMM YYYY');
        },
        numbers: function (number) {
            return Number(number).toLocaleString()
        },
    },

    async created() {
    },

    methods: {
        async runReport() {
            this.onLoad = true
            this.printObj = (await this.$store.dispatch('getObjs', {apidomain:'reports/jalur-outlet?delivery_date='+this.reportDate, parameter:''})).data.data.items
            console.log(this.printObj)
            this.onLoad = false
        },
        onProgress(progress) {
            this.progress = progress;
            console.log(`PDF generation progress: ${progress}%`)
        },
        export2xls() {
            console.log(this.$refs.tableBOM.$el.firstChild.firstChild)
            const wb = utils.table_to_book(this.$refs.tableBOM.$el.firstChild.firstChild)
            writeFileXLSX(wb, "Jalur-Outlet.xlsx")

        },
    }    
}
</script>

<style scoped>
table, th, td {
  border: 1px solid grey;
  border-collapse: collapse;
}
#printresep th, td {
  padding: 10px;
  font-size: 12px;
}
.box {
    border:1px solid grey;
    height:30px;
    width:100px;    
}
</style>